import { Button } from '@/components/ui/button';
import { MessageCircle, Phone } from 'lucide-react';

interface ContactChatHeaderProps {
  phoneNumber?: string;
  isConnected?: boolean;
  onCall?: () => void;
}

export function ContactChatHeader({ phoneNumber, isConnected, onCall }: ContactChatHeaderProps) {
  return (
    <div className="flex items-center justify-between px-4 py-3 bg-primary/10 border-b flex-shrink-0">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center">
          <MessageCircle className="w-5 h-5 text-primary" />
        </div>
        <div>
          <p className="font-medium text-sm">{phoneNumber || 'Sem número'}</p>
          <div className="flex items-center gap-1 text-xs text-muted-foreground">
            {isConnected && (
              <>
                <span className="w-2 h-2 bg-green-500 rounded-full" />
                online
              </>
            )}
          </div>
        </div>
      </div>
      <Button
        variant="ghost"
        size="icon"
        className="h-9 w-9"
        onClick={onCall}
        disabled={!phoneNumber}
      >
        <Phone className="h-4 w-4" />
      </Button>
    </div>
  );
}
